import { SanityAccordions } from '@data/sanity/queries/types/blocks'

import Accordion from '@components/accordion'
import SimplePortableText from '@components/portable-text/simple'

type AccordionsProps = SanityAccordions

const Accordions = ({ items }: AccordionsProps) => {
  return (
    <div className="mb-12 last:mb-0">
      {items.map(({ id, title, content }) => (
        <Accordion key={id} id={id} title={title}>
          <SimplePortableText content={content} className="rc" />
        </Accordion>
      ))}
    </div>
  )
}

export default Accordions
